module.exports = __webpack_public_path__ + "img/Casino_Open.4221b5ff.png";